import { useCallback, useEffect, useState } from "react";
import config from "../config";

// toast = { type: "uploading" | "success" | "warning" | "error", message, action }.
// action = { label, onClick } renders a button (for example Undo) and keeps
// the toast up longer. "uploading" stays until replaced; other types auto-clear.
export default function useToast() {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((type, message, action = null) => {
    setToast({ type, message, action });
  }, []);

  useEffect(() => {
    if (!toast || toast.type === "uploading") return undefined;
    const base = toast.type === "success" ? config.toastDurationMs : config.toastDurationMs * 3;
    const duration = toast.action ? Math.max(base, config.toastDurationMs * 4) : base;
    const timer = setTimeout(() => setToast(null), duration);
    return () => clearTimeout(timer);
  }, [toast]);

  return { toast, showToast };
}
